import * as React from 'react';

import { SVGComponentProps } from './svg.types';

const LinkFileSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => (
  <span className={`inline-block ${wrapperClass || ''}`}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...otherSvgProps}
    >
      <rect width="23" height="23" x="0.5" y="0.5" fill="#fff" rx="1.5"></rect>
      <path fill="#BCBEC2" d="M3 15H21V16H3z"></path>
      <path fill="#BCBEC2" d="M3 17H21V18H3z"></path>
      <path fill="#BCBEC2" d="M3 19H13V20H3z"></path>
      <mask
        id="path-5-outside-1_2971_62667"
        width="11"
        height="10"
        x="3"
        y="4"
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M3 4H14V14H3z"></path>
        <path d="M4.843 12.21c1.121 1.053 2.947 1.053 4.068 0L12.4 8.934a1.85 1.85 0 000-2.73 2.118 2.118 0 00-1.453-.563 2.12 2.12 0 00-1.453.564L6.296 9.207c-.233.22-.361.51-.361.82 0 .309.128.6.36.818.482.452 1.264.452 1.745 0l2.09-1.963a.37.37 0 000-.546.43.43 0 00-.581 0l-2.09 1.963a.43.43 0 01-.582 0 .372.372 0 010-.546l3.197-3.002a1.292 1.292 0 011.744 0 1.11 1.11 0 010 1.638L8.33 11.664c-.801.752-2.105.752-2.906 0a1.86 1.86 0 01-.602-1.365c0-.515.214-1 .602-1.365L8.912 5.66a.37.37 0 000-.546A.424.424 0 008.62 5a.424.424 0 00-.29.113L4.842 8.39A2.604 2.604 0 004 10.299c0 .722.3 1.4.843 1.91z"></path>
      </mask>
      <path
        fill="#55585E"
        d="M4.843 12.21c1.121 1.053 2.947 1.053 4.068 0L12.4 8.934a1.85 1.85 0 000-2.73 2.118 2.118 0 00-1.453-.563 2.12 2.12 0 00-1.453.564L6.296 9.207c-.233.22-.361.51-.361.82 0 .309.128.6.36.818.482.452 1.264.452 1.745 0l2.09-1.963a.37.37 0 000-.546.43.43 0 00-.581 0l-2.09 1.963a.43.43 0 01-.582 0 .372.372 0 010-.546l3.197-3.002a1.292 1.292 0 011.744 0 1.11 1.11 0 010 1.638L8.33 11.664c-.801.752-2.105.752-2.906 0a1.86 1.86 0 01-.602-1.365c0-.515.214-1 .602-1.365L8.912 5.66a.37.37 0 000-.546A.424.424 0 008.62 5a.424.424 0 00-.29.113L4.842 8.39A2.604 2.604 0 004 10.299c0 .722.3 1.4.843 1.91z"
      ></path>
      <path
        stroke="#55585E"
        strokeWidth="0.2"
        d="M4.843 12.21c1.121 1.053 2.947 1.053 4.068 0L12.4 8.934a1.85 1.85 0 000-2.73 2.118 2.118 0 00-1.453-.563 2.12 2.12 0 00-1.453.564L6.296 9.207c-.233.22-.361.51-.361.82 0 .309.128.6.36.818.482.452 1.264.452 1.745 0l2.09-1.963a.37.37 0 000-.546.43.43 0 00-.581 0l-2.09 1.963a.43.43 0 01-.582 0 .372.372 0 010-.546l3.197-3.002a1.292 1.292 0 011.744 0 1.11 1.11 0 010 1.638L8.33 11.664c-.801.752-2.105.752-2.906 0a1.86 1.86 0 01-.602-1.365c0-.515.214-1 .602-1.365L8.912 5.66a.37.37 0 000-.546A.424.424 0 008.62 5a.424.424 0 00-.29.113L4.842 8.39A2.604 2.604 0 004 10.299c0 .722.3 1.4.843 1.91z"
        mask="url(#path-5-outside-1_2971_62667)"
      ></path>
      <rect width="23" height="23" x="0.5" y="0.5" stroke="#D5D7DD" rx="1.5"></rect>
    </svg>
  </span>
);

export default LinkFileSVG;
